export default "__VITE_ASSET__BIaVsloG__"